import React from "react";
import { useCurrency } from "@/lib/currency";

export const CurrencySelector = ({ className = "" }) => {
  const { currency, setCurrency, supported } = useCurrency();
  return (
    <select
      value={currency}
      onChange={(e) => setCurrency(e.target.value)}
      data-testid="currency-selector"
      aria-label="Select display currency"
      className={`bg-transparent border border-border-subtle hover:border-artha-amber focus:border-artha-amber focus:outline-none text-xs font-mono-accent tracking-[0.18em] uppercase px-2 py-1.5 transition-colors ${className}`}
    >
      {supported.map((c) => <option key={c} value={c}>{c}</option>)}
    </select>
  );
};
